export const getURLWithReturn = (to: string, return_url: string | null) => {
  return return_url ? `${to}?return_url=${encodeURIComponent(return_url)}` : to;
}